import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { useInView } from 'react-intersection-observer';
import SentimentVerySatisfiedOutlinedIcon from '@mui/icons-material/SentimentVerySatisfiedOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import KitesurfingOutlinedIcon from '@mui/icons-material/KitesurfingOutlined';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import Grid from '@mui/material/Grid';
import CastleOutlinedIcon from '@mui/icons-material/CastleOutlined';
import OurService from '../services/ourServices';
import { GlobalTheme } from './../../theme';
import Box from '@mui/material/Box';
import CountUp from 'react-countup';
import { Container, Stack, Typography } from '@mui/material';

const Counter = () => {
    const counters = [
        { label: 'Happy Travelers', count: 6734, icon: <SentimentVerySatisfiedOutlinedIcon /> },
        { label: 'Tours Completed', count: 2321, icon: <TrendingUpOutlinedIcon /> },
        { label: 'Star Reviews', count: 4.6, icon: <StarOutlinedIcon /> },
        { label: 'Tours Expert', count: 253, icon: <HandshakeOutlinedIcon /> },
        // { label: 'Tour Destination', count: 5430, icon: <TravelExploreOutlinedIcon /> },
    ];

    const { ref, inView } = useInView({
        triggerOnce: true, // Animates only once when scrolled into view
        threshold: 0,    // Trigger when 30% of the component is visible
    });


    return (
        <React.Fragment>
            <ThemeProvider theme={GlobalTheme}>
                <CssBaseline />
                <Box id='containerOurService' sx={{
                    backgroundColor: GlobalTheme.palette.primary.main,
                }}>
                    <OurService />

                    <Container id='whyChoose' component='section' sx={{ pb: 10 }}>
                        <Typography variant='h2' component='h2' color='white' sx={{ mb: 5, display: 'block', textAlign: 'center' }}>Why Choose Us</Typography>
                        <Container maxWidth='lg'>
                            <Grid container spacing={2} ref={ref}>
                                {counters.map((counter, index) => (
                                    <Grid item xs={6} sm={3} key={`counterGrid${index}`} id={`counterGrid${index}`} sx={{ textAlign: 'center' }}>
                                       <CountUp
  id={`countUp${index}`}
  redraw={inView}
  start={0}
  startOnMount={false}
  useEasing={true}
  end={counter.count}
  duration={8}
  delay={0}
  decimals={counter.count % 1 !== 0 ? 1 : 0}
>

                                            {({ countUpRef }) => (
                                                <Stack width='100%' alignItems='center' id={`counter-stack-${index}`} key={`counter-stack-${index}`} mb={{ sm: 3 }} >
                                                    <Box sx={{

                                                        width: 200, height: { xs: 150, md: 200 },
                                                        borderRadius: 40, border: { lg: `1px solid ${GlobalTheme.palette.common.white}` },
                                                        py: { md: 4 }, px: { lg: 5 }
                                                    }}>
                                                        <Box sx={{ color: GlobalTheme.palette.common.white, transform: 'scale(2)', textAlign: 'center', mt: 2, mb: 2 }}>
                                                            {counter.icon}
                                                        </Box>
                                                        <Stack alignItems='center' sx={{ textAlign: 'center' }}>
                                                            <Typography component='p' variant='h2' fontWeight={500} sx={{ color: GlobalTheme.palette.common.white }} ref={countUpRef}></Typography>
                                                            <Typography variant='subtitle1' component='p' textAlign='center' color={GlobalTheme.palette.common.white} fontWeight={400} sx={{ px: { md: '30%' } }}>{counter.label}</Typography>
                                                        </Stack>
                                                    </Box>
                                                </Stack>
                                            )}
                                        </CountUp>
                                    </Grid>
                                ))}
                            </Grid>
                        </Container>
                    </Container>

                </Box>
            </ThemeProvider>
        </React.Fragment >
    );
};

export default Counter;